import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatTableDataSource, MatDialog } from '@angular/material';

import {
  IcecontrolSettings,
  IcepanelsectionSettings,
  IcepanelSettings,
  IcepanelcontainerRowSettings,
  IcepanelcontainerSettings,

  iceColumnDefinition,
  IcecontrolPermission,
  IceResponsiveMattableSettings
} from '../../../../icemedx-lib/src/components/models/icesettings';

import { Iceutility } from '../../../../icemedx-lib/src/services/iceutility';

import { IceNavService } from '../../../../icemedx-lib/src/components/ice-nav/ice-nav.service';
import { AppService } from '../app.service';
import { IceTypes } from 'projects/icemedx-lib/src/models/icetypes';
import { userTypes } from '../../../../icemedx-lib/src/login/login.config';
import { DomainService } from '../../../../icemedx-lib/src/services/domain/domain.service';
import { IceEntity } from '../../../../icemedx-lib/src/models/core/IceEntity';
import { IBaseView } from '../../../../icemedx-lib/src/components/baseview.component';
import { Validators, FormControl } from '@angular/forms';
import { MedicalcodesService } from '../../../../icemedx-lib/src/services/medicalcodes/medicalcodes.service';
import { AccountingService } from '../../../../icemedx-lib/src/services/accounting/accounting.service';
import { VendorService } from '../../../../icemedx-lib/src/services/vendor/vendor.service';
import { PatientService } from '../../../../icemedx-lib/src/services/patient/patient.service';
import { ProviderService } from '../../../../icemedx-lib/src/services/provider/provider.service';
import { PharmacyService } from '../../../../icemedx-lib/src/services/pharmacy/pharmacy.service';
import { PayerService } from '../../../../icemedx-lib/src/services/payer/payer.service';
import { superbillchargesindex } from '../../../../icemedx-lib/src/models/accounting/medservice/superbillchargesindex';
import { superbillcharges } from '../../../../icemedx-lib/src/models/accounting/medservice/superbillcharges';
import { medicalservicereference } from '../../../../icemedx-lib/src/models/accounting/medservice/medicalservicereference';
import { medicalservice } from '../../../../icemedx-lib/src/models/accounting/medservice/medicalservice';
import { superbillindex } from '../../../../icemedx-lib/src/models/accounting/superbillindex';
import { basecodereference } from '../../../../icemedx-lib/src/models/ehr/subs/basecodereference';
import { patient } from '../../../../icemedx-lib/src/models/domain/patient';
import { provider } from '../../../../icemedx-lib/src/models/domain/provider';
import { pharmacy } from '../../../../icemedx-lib/src/models/domain/pharmacy';
import { vendor } from '../../../../icemedx-lib/src/models/domain/vendor';
import { payer } from '../../../../icemedx-lib/src/models/domain/payer';
import { subscriber } from '../../../../icemedx-lib/src/models/domain/subscriber';
import { ScheduleService } from '../../../../icemedx-lib/src/services/schedule/schedule.service';
import { encounterindex } from '../../../../icemedx-lib/src/models/ehr/encounterindex';
import { IcepanelDialog } from '../../../../icemedx-lib/src/components/icepaneldialog/icepaneldialog';
import { encounter } from '../../../../icemedx-lib/src/models/ehr/encounter';
import { BreadcrumType } from '../../../../icemedx-lib/src/services/baseapp.service';
import { BreadcrumbService } from '../../../../icemedx-lib/src/services/breadcrumb/breadcrumb.service';
import { AppConstants } from '../app-constants';

const BillingActionDomainType = "BillingActionDomainType";
const BillingActionNameofDomain = "BillingActionNameofDomain";
const BillingActionDomainOrder = "BillingActionDomainOrder";
const StatusCheckbox = "StatusCheckbox";
const SectionName = "ServiceSection";
const OtherItemTitle = "OtherItemTitle";

@Component({
  selector: 'app-serviceitemcharge',
  templateUrl: './serviceitemcharge.component.html',
  styleUrls: ['./serviceitemcharge.component.scss'],
  providers: [AppService, IceNavService]
})
export class ServiceitemChargeComponent implements OnInit, IBaseView {
  // data members
  private superbillChargesKey: string = null;
  hideAccountingPeriod: boolean = true;
  private showPatientSections: boolean = false;

  // member settings
  chargeViewSettings: IcepanelcontainerSettings = null;
  chargePermission: IcecontrolPermission = null;

  //////////////////////
  // Order Info. Controls
  private ctrlBillingDomainType: IcecontrolSettings = new IcecontrolSettings("iceselect", { menuItems: DomainService.getDomainTypes(), width: "100%" }, null, null, BillingActionDomainType, "Type of Service Bucket") // Type of Receiving or Checkout Bill
    .setControlName(BillingActionDomainType)
    .createFormControl(0, [Validators.required]);
  private ctrlBillingDomainNameCtrl = new IcecontrolSettings("iceautocomplete", { menuItems: [], width: "100%" }, null, null, BillingActionNameofDomain, "Enter Name of Network Domain") // ...Network Domain Bill To or From
    .setControlName(BillingActionNameofDomain)
    .createFormControl("", [Validators.required]);
  private ctrlBillingDomainOrderCtrl = new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, BillingActionDomainOrder, "Select Service Charge Bucket No.") // ...Network Domain Bill Order No.
    .setControlName(BillingActionDomainOrder)
    .createFormControl("", [Validators.required]);

  fromDomainType: IceTypes.ACCOUNT_TYPE = null;
  fromDomain: string = null;
  toDomainType: IceTypes.ACCOUNT_TYPE = null;
  toDomain: string = null;

  private appointmentKeys: string[] = [];
  private medServiceKeys: string[] = [];
  private encounters: encounterindex[] = [];
  private billingDomainSection: IcepanelsectionSettings = null;
  private billingDomainNameAndOrderSection: IcepanelsectionSettings = null;
  private loaderSection: IcepanelsectionSettings = null;
  private taxonomyFilterSection: IcepanelsectionSettings = null;
  private newItem: any = {};
  private newOrder: any = { name: "Create New Service Charge Bucket", value: "" };
  private srcTypeMapDataSource: any = {};
  private sectionMap: any = {};
  private sourceRef: string[] = null;
  private grandTotal: number = 0;
  private grandTotalControl: IcecontrolSettings = null;
  private grandTotalSection: IcepanelsectionSettings = null;
  private sections: IcepanelsectionSettings[] = [];
  private newOtherItemSectionTag: string = "";
  private newOtherItemControls: IcecontrolSettings[];
  private otherItemsTitleCtrl: IcecontrolSettings = null;
  private otherItemsPriceCtrl: IcecontrolSettings = null;
  private otherItemsQuantityCtrl: IcecontrolSettings = null;
  private filterCtrl: IcecontrolSettings = null;
  private taxonomyCodes = [];
  private activeTaxonomy: string = "";
  private superbillPermission: userTypes.USER_FEATURE_ACCESS;
  private serviceSelectionPermission: userTypes.USER_FEATURE_ACCESS;
  private hasAccountingJournalPermission: boolean = false;
  private deleteConfirmationDialogRef: any = null;
  private encounterRef: encounter = null;
  private serviceErrorMessage: string = "The service could not be removed";
  private serviceAddErrorMessage: string = "The service could not be added";
  private previousPage: string = "";

  constructor(private appSvc: AppService,
    private navSvc: IceNavService,
    private domainSvc: DomainService,
    private accSvc: AccountingService,
    private vendorSvc: VendorService,
    private proSvc: ProviderService,
    private pharmSvc: PharmacyService,
    private payerSvc: PayerService,
    private medCodeSvc: MedicalcodesService,
    private ptSvc: PatientService,
    private scheduleSvc: ScheduleService,
    private breadcrumbStoreService: BreadcrumbService,
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog) {

    this.appSvc.defaultMenus();
    this.addBreadcrumbs();

    this.route.params.subscribe(next => {
      this.fromDomainType = <IceTypes.ACCOUNT_TYPE>Iceutility.toLong(next.fromDomainType);
      this.fromDomain = next.fromDomain;
      this.toDomainType = <IceTypes.ACCOUNT_TYPE>Iceutility.toLong(next.toDomainType);
      this.toDomain = next.toDomain;

      if (this.fromDomain != null && this.fromDomain.length > 0 && this.fromDomainType != null && this.fromDomainType != IceTypes.ACCOUNT_TYPE.actNone) {
        this.appSvc.openAccount(this.fromDomain, this.fromDomainType);
      }

      this.showPatientSections = this.toDomainType === IceTypes.ACCOUNT_TYPE.actPatient;
      this.superbillChargesKey = next.key;
      if (next.sourceRef != null) {
        this.sourceRef = next.sourceRef.split(",");
      }

      let feaAccess = this.appSvc.getPermission(userTypes.USER_FEATURES.ufSuperBill).default_access;
      this.chargePermission = new IcecontrolPermission(userTypes.USER_FEATURES.ufSuperBill, feaAccess);

      if (feaAccess == userTypes.USER_FEATURE_ACCESS.ufaNone) {
        this.domainSvc.logMessage(IceTypes.LOGTYPE.ltError, "You do not have access to view this data.");
        return;
      }
      this.chargeViewSettings = this.viewSetup(new IceEntity());
    });

    this.route.fragment.subscribe(data => {
      let breadcrumbTitle: string = "";

      if (Iceutility.isdefined(data)) {
        this.previousPage = data;

        if (data === AppConstants.ServiceChargeHistoryPage) {
          breadcrumbTitle = "Service Charge History - Service Charge Bucket";
        } else if (data === AppConstants.OutstandingBalancePage) {
          breadcrumbTitle = "Oustanding Balance - Service Charge Bucket";
        } else if (data === AppConstants.LedgerPage) {
          breadcrumbTitle = "Ledger - Service Charge Bucket";
        }
      } else {
        this.previousPage = AppConstants.ServiceItemChargePage;
        breadcrumbTitle = "Service Charge Bucket";
      }

      this.breadcrumbStoreService.updateBreadcrumb(BreadcrumType.btBranch.toString(), {
        display: breadcrumbTitle,
        data: null,
        active: true,
        link: "",
        history: []
      });
    });
  }

  addBreadcrumbs() {
    this.breadcrumbStoreService.updateBreadcrumb(BreadcrumType.btTree.toString(), { display: "Accounting", data: null, active: false, link: "/accounting/summary", history: [] });
  }

  getBreadcrumbs(): any {
    return this.appSvc.getBreadcrumbs();
  }

  ngOnInit() {
    this.appSvc.refreshMenus();
    if (this.sourceRef) {
      this.hideNavigation();
    }

    window.addEventListener("message", event => {
      try {
        if (Iceutility.isdefined(event.data) && event.data.indexOf("ADD_DIAGNOSIS") >= 0) {
          let diagnosisData = JSON.parse(event.data);

          if (Iceutility.isdefined(diagnosisData) && Iceutility.isdefined(diagnosisData.type) && diagnosisData.type === "ADD_DIAGNOSIS") {
            console.log(diagnosisData);
            // update diagnosis table here
            let diagnosisTable = this.srcTypeMapDataSource[IceTypes.SourceType.srcDiagnosis];

            if (Iceutility.isdefined(diagnosisTable) && Iceutility.isdefined(diagnosisTable.data)) {
              for (let i = 0; i < diagnosisData.diagnosis.length; i++) {
                let diag = diagnosisData.diagnosis[i];

                let row = {
                  name: diag.title,
                  code: diag.icd_code,
                  from: !isNaN(diag.onset_of_illness_date) ?
                    Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(diag.onset_of_illness_date)) :
                    Iceutility.getDateTextEx(diag.onset_of_illness_date),
                  to: !isNaN(diag.resolution_date) ?
                    Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(diag.resolution_date)) :
                    Iceutility.getDateTextEx(diag.resolution_date),
                  src_type: IceTypes.SourceType.srcDiagnosis,
                  superbill_key: diag.superbill_key,
                  medical_service_key: "",
                  checked: false,
                  trans_account: "",
                  taxonomy_code: "",
                  sub_type: diag.sub_type,
                  base_code_reference_key: diag.diagnosis_key
                };
                diagnosisTable.data.push(row);
              }
              diagnosisTable._updateChangeSubscription();
            }
          }
        }
      } catch (e) { }
    }, false);

    // get the breadcrumbs to see if there's a patient in the YARD
    let data: any = this.breadcrumbStoreService.getYardData();
    if (Iceutility.isdefined(data.account) && Iceutility.isdefined(data.patientName)) {
      this.ctrlBillingDomainType.getFormControl().setValue(IceTypes.ACCOUNT_TYPE.actPatient);
      this.ctrlBillingDomainNameCtrl.getFormControl().setValue(JSON.stringify([{ name: data.patientName, value: data.account }]));
      this.setBillToOrders(data.account);
    }
  }

  createBillingPanel(): IcepanelSettings {
    let panel: IcepanelSettings = null;
    try {
      let controls: IcecontrolSettings[] = [];
      let headerControls: IcecontrolSettings[] = [];

      controls.push(
        //this.ctrlBillingAction,
      );

      this.superbillPermission = this.appSvc.getPermission(userTypes.USER_FEATURES.ufSuperBill).default_access;
      this.hasAccountingJournalPermission = this.appSvc.getPermission(userTypes.USER_FEATURES.ufAccountingJournals).default_access !== userTypes.USER_FEATURE_ACCESS.ufaNone;
      this.serviceSelectionPermission = this.appSvc.getPermission(userTypes.USER_FEATURES.ufClinicalNotes).default_access;

      if (this.sourceRef == null) {
        headerControls.push(
          new IcecontrolSettings("icebutton", { class: "fas fa-wallet", width: "50px", tooltip: "Go to Balance" }, null, null, "Save"),
          new IcecontrolSettings("icecancelbutton", { class: "fas fa-times", width: "50px" }, null, null, "Cancel")
        );
      }

      this.grandTotalControl = new IcecontrolSettings("icelabel", { class: ["grand-total"], value: "Total: " }, {}, {}, "GrandTotal", "", new IcecontrolPermission(userTypes.USER_FEATURES.ufAccountingJournals, userTypes.USER_FEATURE_ACCESS.ufaReadOnly)).setControlName("GrandTotal")
        .createFormControl(0, []);
      this.grandTotalSection = new IcepanelsectionSettings("GrandTotalSection", { class: [""], styles: { width: "100%" } }, null, [this.grandTotalControl], []).setShow(false);

      this.otherItemsTitleCtrl = new IcecontrolSettings("iceautocomplete", { menuItems: [], width: "300px", section: this.newOtherItemSectionTag }, null, null, OtherItemTitle, "Enter Title")
        .setControlName(OtherItemTitle)
        .createFormControl("", [Validators.required]);

      this.otherItemsPriceCtrl = new IcecontrolSettings("iceinput", { width: "120px", inputType: "number" }, null, {}, "price", "Enter Unit Price")
        .setControlName("price")
        .createFormControl("", [Validators.required]);

      this.otherItemsQuantityCtrl = new IcecontrolSettings("iceinput", { width: "120px", inputType: "number" }, null, {
        change: (event) => {
          this.newItem["quantity"] = Iceutility.toDouble(event.currentTarget.value);
          }
        }, "quantity", "Enter Quantity")
        .setControlName("quantity")
        .createFormControl("", [Validators.required]);

      this.newOtherItemSectionTag = "NewOtherItemSection";
      this.newOtherItemControls = [
        this.otherItemsTitleCtrl,
        this.otherItemsPriceCtrl,
        this.otherItemsQuantityCtrl
      ];

      this.billingDomainSection = new IcepanelsectionSettings("BillingDomainPanelSection", { class: [""], styles: { width: "100%" } }, null, [
        this.ctrlBillingDomainType,
      ], []).setShow(this.sourceRef == null);

      let nameAndOrderSectionControls = [];
      if (this.sourceRef == null) {
        nameAndOrderSectionControls.push(this.ctrlBillingDomainNameCtrl);
      }
      nameAndOrderSectionControls.push(this.ctrlBillingDomainOrderCtrl);

      this.billingDomainNameAndOrderSection = new IcepanelsectionSettings("BillingPanelNameAndOrderSection", { class: [""], styles: { width: "100%" } }, [], nameAndOrderSectionControls, []).setShow(true);

      this.loaderSection = new IcepanelsectionSettings("LoaderSection", { class: [""], styles: { width: "100%" } }, [], [], []);

      this.taxonomyFilterSection = new IcepanelsectionSettings("TaxonomyFilterSection", { class: [""], styles: { width: "100%" } }, null, [], []).setShow(false);

      this.sections = [
        new IcepanelsectionSettings("BillingPanelSection", { class: [""], styles: { width: "100%" } }, null, controls, []),
        this.billingDomainSection,
        this.billingDomainNameAndOrderSection,
        this.grandTotalSection,
        this.taxonomyFilterSection,
        this.loaderSection
      ];

      panel = new IcepanelSettings("BillingPanel", Iceutility.guid(false), this.sourceRef != null ? "" : "Service Charge Bucket", "", this.sections, headerControls)
        .enableForm();

      if (this.toDomainType != null)
        this.ctrlBillingDomainType.getFormControl().setValue(Iceutility.toLong(this.toDomainType));

      if (!Iceutility.isStringUndefinedNullOrEmpty(this.superbillChargesKey)) {
        this.accSvc.getBill(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), this.superbillChargesKey).subscribe(
          data => {
            let opts = [];

            if (data == null || data.length == 0) return;

            let bill: superbillcharges = <superbillcharges>data[0];
            if (bill == null) return;

            // Set Bill Type
            this.ctrlBillingDomainType.getFormControl().setValue(Iceutility.toLong(bill.to_account_type));
            this.ctrlBillingDomainType.setDisabled(true);

            // Set Bill to
            this.toDomain = bill.to_trans_account;
            this.toDomainType = bill.to_account_type;
            this.ctrlBillingDomainNameCtrl.getFormControl().setValue(JSON.stringify([{ value: bill.to_trans_account, name: bill.bill_to }]));
            this.breadcrumbStoreService.updateBreadcrumb(BreadcrumType.btYard.toString(), {
              display: bill.bill_to,
              data: null,
              active: true,
              link: (Iceutility.formatUrl(this.router) + `#${bill.to_trans_account}`),
              history: []
            });

            // Only one should be in bill charges control
            let orddesc = Iceutility.isTextDateTime(bill.created) ? Iceutility.getDateTextEx(bill.created) : Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(bill.created))
              + " - " + bill.superbill_charges_key.substr(0, 10);
            this.ctrlBillingDomainOrderCtrl.setOptions([{ value: bill.superbill_charges_key, name: orddesc}]);
            let frmOrder: FormControl = this.ctrlBillingDomainOrderCtrl.getFormControl();
            frmOrder.setValue(bill.superbill_charges_key);

            // Disable order
            this.ctrlBillingDomainOrderCtrl.setDisabled(true);
            // Load services
            this.loadMedicalServices(data);
          },
          error => {
            console.log(JSON.stringify(this.medCodeSvc.getLastErrors()));
          });
      }
      else {
        this.breadcrumbStoreService.updateBreadcrumb(BreadcrumType.btBranch.toString(), { display: "Service Charge Bucket", data: null, active: true, link: "", history: [] });
        if (this.sourceRef != null) {
          this.getPatientDiagnosis(this.toDomain);
          this.setBillToOrders(this.toDomain);
        }
        else {
          if (this.toDomainType != null && this.toDomain != null && this.toDomain.length > 0) {            
            switch (this.toDomainType) {
              case IceTypes.ACCOUNT_TYPE.actPatient: {
                this.domainSvc.getPatient(this.toDomain, this.appSvc.getCurrentAccount()).subscribe(
                  data => {
                    if (data != null && data.length > 0) {
                      let pt = <patient>data[0];
                      this.ctrlBillingDomainNameCtrl.getFormControl().setValue(JSON.stringify([{ value: pt.trans_account, name: pt.getName() }]));
                      this.getPatientDiagnosis(pt.trans_account);
                      this.setBillToOrders(pt.trans_account, true, false);
                    }
                  },
                  error => {
                    console.log(JSON.stringify(this.domainSvc.getLastErrors()));
                  });
                break;
              }
              case IceTypes.ACCOUNT_TYPE.actProvider:
              case IceTypes.ACCOUNT_TYPE.actFacility: {
                this.domainSvc.getProvider(this.toDomain).subscribe(
                  data => {
                    if (data != null && data.length > 0) {
                      let pro = <provider>data[0];
                      this.ctrlBillingDomainNameCtrl.getFormControl().setValue(JSON.stringify([{ value: pro.trans_account, name: pro.getdisplayname(this.toDomainType == IceTypes.ACCOUNT_TYPE.actFacility) }]));
                      this.setBillToOrders(pro.trans_account, true, false);
                    }
                  },
                  error => {
                    console.log(JSON.stringify(this.domainSvc.getLastErrors()));
                  });
                break;
              }
              case IceTypes.ACCOUNT_TYPE.actPharmacy: {
                this.domainSvc.getPharmacy(this.toDomain).subscribe(
                  data => {
                    if (data != null && data.length > 0) {
                      let pharm = <pharmacy>data[0];
                      this.ctrlBillingDomainNameCtrl.getFormControl().setValue(JSON.stringify([{ value: pharm.trans_account, name: pharm.getdisplayname() }]));
                      this.setBillToOrders(pharm.trans_account, true, false);
                    }
                  },
                  error => {
                    console.log(JSON.stringify(this.domainSvc.getLastErrors()));
                  });
                break;
              }
              case IceTypes.ACCOUNT_TYPE.actVendor: {
                this.domainSvc.getVendor(this.toDomain).subscribe(
                  data => {
                    if (data != null && data.length > 0) {
                      let ven = <vendor>data[0];
                      this.ctrlBillingDomainNameCtrl.getFormControl().setValue(JSON.stringify([{ value: ven.trans_account, name: ven.getdisplayname(true) }]));
                      this.setBillToOrders(ven.trans_account, true, false);
                    }
                  },
                  error => {
                    console.log(JSON.stringify(this.domainSvc.getLastErrors()));
                  });
                break;
              }
              case IceTypes.ACCOUNT_TYPE.actPayer: {
                this.domainSvc.getPayer(this.toDomain).subscribe(
                  data => {
                    if (data != null && data.length > 0) {
                      let pyr = <payer>data[0];
                      this.ctrlBillingDomainNameCtrl.getFormControl().setValue(JSON.stringify([{ value: pyr.trans_account, name: pyr.getdisplayname(true) }]));
                      this.setBillToOrders(pyr.trans_account, true, false);
                    }
                  },
                  error => {
                    console.log(JSON.stringify(this.domainSvc.getLastErrors()));
                  });
                break;
              }
              case IceTypes.ACCOUNT_TYPE.actSubscriber: {
                this.domainSvc.getSubscriber(this.toDomain, this.appSvc.getCurrentAccount()).subscribe(
                  data => {
                    if (data != null && data.length > 0) {
                      let sub = <subscriber>data[0];
                      this.ctrlBillingDomainNameCtrl.getFormControl().setValue(JSON.stringify([{ value: sub.trans_account, name: sub.getName() }]));
                      this.setBillToOrders(sub.trans_account, true, false);
                    }
                  },
                  error => {
                    console.log(JSON.stringify(this.domainSvc.getLastErrors()));
                  });
                break;
              }
            }
          }          
        }
      }
    }
    catch (e) {
      console.log(e);
    }
    return panel;
  }

  onToolbarMenuItemClick(event) {
    if (Iceutility.isdefined(event) && Iceutility.isdefined(event.selectedItem) && Iceutility.isdefined(event.selectedItem.data)) {
      const account = event.selectedItem.data.account;
      const patient = event.selectedItem.data.patientName;

      if (this.previousPage === AppConstants.ServiceChargeHistoryPage) {
        this.router.navigate([`/accounting/servicechargehistory/${account}`]);
      } else if (this.previousPage === AppConstants.ServiceItemChargePage) {
        this.ctrlBillingDomainType.getFormControl().setValue(IceTypes.ACCOUNT_TYPE.actPatient);
        this.ctrlBillingDomainNameCtrl.getFormControl().setValue(JSON.stringify([{ name: patient, value: account }]));

        // reset the total
        this.grandTotal = 0;
        this.setTotal();
        this.setBillToOrders(account);
      } else if (this.previousPage === AppConstants.OutstandingBalancePage) {
        this.router.navigate([`/accounting/outstandingbalance/${this.superbillChargesKey}`]);
      } else if (this.previousPage === AppConstants.LedgerPage) {
        this.router.navigate([`/accounting/ledger`]);
      }
    }
  }

  viewSetup(dat: IceEntity): IcepanelcontainerSettings {
    let setup: IcepanelcontainerSettings = null;
    try {
      let feaAccess = this.appSvc.getPermission(userTypes.USER_FEATURES.ufSuperBill).default_access;

      if (feaAccess == userTypes.USER_FEATURE_ACCESS.ufaNone) {
        this.domainSvc.logMessage(IceTypes.LOGTYPE.ltError, "You do not have access to view this data.");
        return null;
      }
      if (dat == null) {
        return null;
      }

      let billPanel: IcepanelSettings = this.createBillingPanel()
        .enableForm();

      let panels: IcepanelSettings[] = [
        billPanel,
      ];

      let panelrows: IcepanelcontainerRowSettings[] = [new IcepanelcontainerRowSettings(panels)];
      setup = new IcepanelcontainerSettings("ServiceItemViewContainer", panelrows);
      this.setTaxonomyCodeList();
    }
    catch (e) {
      console.log(e);
    }
    return setup;
  }

  getBillingType(): IceTypes.ACCOUNT_TYPE {
    let ret: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
    let ctrType: FormControl = this.ctrlBillingDomainType.getFormControl();
    if (ctrType != null) {
      ret = ctrType.value;
    }
    return ret;
  }

  getBillingDomain(): any {
    let ret = null;
    let ordDomainControl: FormControl = this.ctrlBillingDomainNameCtrl.getFormControl();
    if (this.sourceRef != null) {
      // To do let's pass the name in param list or lookup load 
      ret = [{ value: this.toDomain, name: "" }]; // Lets always create an object for caller to handle
    } else if (ordDomainControl != null && ordDomainControl.value != null && ordDomainControl.value.length > 0) {
      try {
        let domObj = JSON.parse(ordDomainControl.value);
        if (domObj == null || domObj.length == 0) throw "Invalid order account selection.";
        ret = domObj;
      }
      catch (e) {
        console.log(e);
      }
    }
    return ret;
  }

  getBillingOrder(): string {
    let ret = "";
    let frmOrder: FormControl = this.ctrlBillingDomainOrderCtrl.getFormControl();
    if (frmOrder != null && frmOrder.value != null) {
      try {
        let ordObj = frmOrder.value;
        if (ordObj == null || ordObj.length == 0) throw "Invalid order selection.";
        ret = ordObj;
      }
      catch (e) {
        console.log(e);
      }
    }
    return ret;
  }

  getBillingTemplates(medicalServices, diagnosis): void {
    this.accSvc.getBillTemplates(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), this.toDomainType, "").subscribe(
      billTemplates => {
        if (billTemplates == null || billTemplates.length == 0) {
          this.showHideProgressSpinner(false);
          this.domainSvc.logMessage(IceTypes.LOGTYPE.ltWarning, "No billing templates found.");
          this.sections = [];
          return;
        }
        
        this.filterCtrl = new IcecontrolSettings("icebuttongroup", {
          activeButton: "", groupSettings: [
            { text: "All", onclick: (event) => { this.onTaxonomyClick(event); } }
          ]
        }, null, null, "", "")
          .setControlName("taxonomyFilter");
        let templates: superbillindex[] = <superbillindex[]>billTemplates;
        this.taxonomyFilterSection.setShow(true);

        for (let i = 0; i < templates.length; i++) {
          let tempidx: superbillindex = templates[i];
          if (tempidx == null) continue;

          this.accSvc.getBillTemplate(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), tempidx.superbill_key).subscribe(
            superbillData => {
              if (superbillData && superbillData.length > 0) {
                let superbill = superbillData[0],
                  subtypes = superbill.SUBTYPES;

                // get the taxonomy description
                let taxonomyCode = this.taxonomyCodes.filter(c => c.code === superbill.taxonomy_code),
                  taxonomyCodeDescription = "";

                if (taxonomyCode && taxonomyCode.length > 0) {
                  taxonomyCodeDescription = taxonomyCode[0].description;
                }

                // check if the taxonomy is already added to the list
                if (this.filterCtrl.properties.groupSettings.map(function (e) { return e.text; }).indexOf(taxonomyCodeDescription) === -1) {
                  this.filterCtrl.properties.groupSettings.push({ text: taxonomyCodeDescription, onclick: (event) => { this.onTaxonomyClick(event); } }
                  );
                  // select default taxonomy selected
                  if (Iceutility.isStringUndefinedNullOrEmpty(this.activeTaxonomy)) {
                    this.filterCtrl.properties.activeButton = this.activeTaxonomy = taxonomyCodeDescription;
                    this.taxonomyFilterSection.controls.push(this.filterCtrl);
                  }
                }
                
                for (var isubtype = 0; isubtype < subtypes.length; isubtype++) {
                  let subtype = subtypes[isubtype];
                  if (subtype == null) continue;

                  let srcMapKey = subtype.src_type,
                    codes = subtype.CODES;

                  for (var icode = 0; icode < codes.length; icode++) {
                    let code: basecodereference = codes[icode];
                    if (code == null) continue;

                    let from = "", to = "", skipMedService = false, skipDiagnosis = false;

                    for (var imedServ = 0; imedServ < medicalServices.length; imedServ++) {
                      let tempMedServ = medicalServices[imedServ];
                      if (!Iceutility.isdefined(tempMedServ)) continue;

                      if (tempMedServ.code === code.code && tempMedServ.src_type === srcMapKey) {
                        // this service is already attached to the bill.
                        // skipping the rendering of this service to avoid duplicate display
                        skipMedService = true;
                        tempMedServ.superbill_key = superbill.superbill_key;
                        break;
                      }
                    }

                    for (var idiag = 0; idiag < diagnosis.length; idiag++) {
                      let tempDiag = diagnosis[idiag];
                      if (!Iceutility.isdefined(tempDiag )) continue;

                      if (tempDiag.icd_code === code.code) {
                        // this service is already attached to the bill.
                        // skipping the rendering of this service to avoid duplicate display
                        skipDiagnosis = true;
                        tempDiag.title = code.title
                        tempDiag.superbill_key = superbill.superbill_key;
                        break;
                      }
                    }

                    if (!skipMedService && !skipDiagnosis) {
                      let obj = {
                        name: code.title,
                        code: code.code,
                        from: from,
                        to: to,
                        price: code.price,
                        quantity: 1,
                        total: Iceutility.toDouble(code.price),
                        src_type: srcMapKey,
                        superbill_key: superbill.superbill_key,
                        medical_service_key: "",
                        checked: false,
                        trans_account: "",
                        taxonomy_code: taxonomyCodeDescription,
                        sub_type: subtype.sub_type,
                        base_code_reference_key: srcMapKey === IceTypes.SourceType.srcDiagnosis.toString() ? "" : code.base_code_reference_key
                      };
                      this.renderMedicalServiceTable(srcMapKey, obj, obj.checked, srcMapKey === IceTypes.SourceType.srcOther.toString());
                    }
                  }
                }

                if (i === templates.length - 1) {
                  let nonOtherItems = medicalServices.filter(m => m.src_type != IceTypes.SourceType.srcOther.toString());
                  let otherItems = medicalServices.filter(m => m.src_type === IceTypes.SourceType.srcOther.toString());
                  // make sure all tables are rendered
                  // add other items table and edit section
                  this.buildAndRenderMedicalService(nonOtherItems);

                  setTimeout(() => {
                    if (!this.appSvc.getEditPanelSection(this.newOtherItemSectionTag)) {
                      this.sectionMap[this.newOtherItemSectionTag] = this.appSvc.viewEditPanelSection(this.newOtherItemSectionTag, this.newOtherItemControls, true);
                      this.sections.push(this.sectionMap[this.newOtherItemSectionTag]);
                    }
                  }, 500);

                  if (otherItems.length === 0) {
                    setTimeout(() => {
                      this.renderMedicalServiceTable(IceTypes.SourceType.srcOther.toString(), null, false, true);
                    }, 500);
                  } else {
                    this.buildAndRenderMedicalService(otherItems);
                  }

                  if (Iceutility.isdefined(diagnosis)) {
                    for (var idiag = 0; idiag < diagnosis.length; idiag++) {
                      let tableKey = IceTypes.SourceType.srcDiagnosis.toString(),
                        tempDiagnosis = diagnosis[idiag],
                        obj = {
                          name: tempDiagnosis.title,
                          code: tempDiagnosis.icd_code,
                          from: !isNaN(tempDiagnosis.onset_of_illness_date) ?
                            Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(tempDiagnosis.onset_of_illness_date)) :
                            Iceutility.getDateTextEx(tempDiagnosis.onset_of_illness_date),
                          to: !isNaN(tempDiagnosis.resolution_date) ?
                            Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(tempDiagnosis.resolution_date)) :
                            Iceutility.getDateTextEx(tempDiagnosis.resolution_date),
                          src_type: tableKey,
                          superbill_key: tempDiagnosis.superbill_key,
                          medical_service_key: "",
                          checked: true,
                          trans_account: "",
                          taxonomy_code: taxonomyCodeDescription,
                          sub_type: tempDiagnosis.sub_type,
                          base_code_reference_key: tempDiagnosis.diagnosis_key
                        };

                      if (this.srcTypeMapDataSource[tableKey] && this.srcTypeMapDataSource[tableKey].data) {
                        let foundDiag = this.srcTypeMapDataSource[tableKey].data.find(d => d.code === obj.code);
                        if (foundDiag) {
                          foundDiag.name = Iceutility.isStringUndefinedNullOrEmpty(foundDiag.name) ? obj.name : foundDiag.name;
                          foundDiag.from = obj.from;
                          foundDiag.to = obj.to;
                          foundDiag.base_code_reference_key = obj.base_code_reference_key;
                          foundDiag.checked = true;
                          this.srcTypeMapDataSource[tableKey]._updateChangeSubscription();
                        }
                        else {
                          if (!Iceutility.isStringUndefinedNullOrEmpty(obj.name)) {
                            this.renderMedicalServiceTable(tableKey, obj, obj.checked, false);
                          }
                        }
                      } else {
                        if (!Iceutility.isStringUndefinedNullOrEmpty(obj.name)) {
                          this.renderMedicalServiceTable(tableKey, obj, obj.checked, false);
                        }
                      }
                    }                    
                  }
                  this.showHideProgressSpinner(false);
                }
              }
            },
            error => {
              console.log(JSON.stringify(this.accSvc.getLastErrors()));
            });
        }
      }, error => {
        console.log(JSON.stringify(this.medCodeSvc.getLastErrors()));
      });
  }

  updateItemSubmitControls(): void {
    let domObj = this.getBillingDomain();
    let ordObj = this.getBillingOrder();
    if (domObj != null && ordObj != null) {
      //this.ctrlBillingDomainItemEntryCtrl.setReadonly(false);
      //this.ctrlBillingDomainItemSubmit.setDisabled(false);
    }
    else {
      //this.ctrlBillingDomainItemEntryCtrl.setReadonly(true);
      //this.ctrlBillingDomainItemSubmit.setDisabled(true);
    }
  }

  setBillToOrders(billTo: string, loadMedServices: boolean = true, defaultOrder: boolean = true) {
    if (billTo == null || billTo.length == 0) return;
    this.accSvc.getBills(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), billTo).subscribe(
      data => {
        let opts = [],
          selectedBill;

        if (data == null || data.length == 0) {
          opts.push(this.newOrder);
        } else if (data != null && data.length > 0) {
          let bills: superbillchargesindex[] = <superbillchargesindex[]>data;

          if (this.sourceRef != null && this.sourceRef.length > 1 && Iceutility.toLong(this.sourceRef[0]) == IceTypes.SourceType.srcEncounterNotes) {
            opts.push(this.newOrder);
            this.ctrlBillingDomainOrderCtrl.setOptions(opts);

            let srcKey = this.sourceRef[1];
            this.ptSvc.getEncounter(this.appSvc.getCurrentAccount(), this.toDomain, srcKey, this.appSvc.getCurrentAccountType()).subscribe(
              data => {
                if (data != null && data.length > 0) {
                  this.encounterRef = data[0];
                  if (this.encounterRef.BILLS.length == 0) {
                    let startDate = Iceutility.isTextDateTime(this.encounterRef.time_slot_start) ? Iceutility.GetLocalDate(this.encounterRef.time_slot_start) : Iceutility.ConvertFromDotNetServerTime(this.encounterRef.time_slot_start);
                    for (let i = 0; i < bills.length; i++) {
                      let bill = bills[i];
                      let billDate = Iceutility.GetLocalDate(bill.created);
                      if (billDate.getFullYear() == startDate.getFullYear()
                        && billDate.getMonth() == startDate.getMonth()
                        && Math.abs(billDate.getDate() - startDate.getDate()) <= 1) {
                        let orddesc = Iceutility.getDateTextEx(bill.created);
                        orddesc += " - " + bill.superbill_charges_key.substr(0, 10)
                        orddesc += " - On same day as Encounter";
                        opts.push({ value: bill.superbill_charges_key, name: orddesc });
                      }
                    }
                    if (defaultOrder) {
                      let frmOrder: FormControl = this.ctrlBillingDomainOrderCtrl.getFormControl();
                      let billToSetKey: string = opts[opts.length - 1].value;
                      if (billToSetKey.length == 0)
                        this.addBill();
                      else
                        frmOrder.setValue(billToSetKey);
                    }
                  }
                  else {
                    for (let ib = 0; ib < this.encounterRef.BILLS.length; ib++) {
                      let billref = this.encounterRef.BILLS[ib];
                      let fndBill = bills.filter(b => b.superbill_charges_key == billref.superbill_charges_key);
                      if (fndBill.length > 0) {
                        let orddesc = Iceutility.isTextDateTime(fndBill[0].created) ? Iceutility.getDateTextEx(fndBill[0].created) : Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(fndBill[0].created));
                        orddesc += " - " + fndBill[0].superbill_charges_key.substr(0, 10)
                        orddesc += " - Assigned to Encounter";
                        opts.push({ value: fndBill[0].superbill_charges_key, name: orddesc });
                      }
                    }
                    this.ctrlBillingDomainOrderCtrl.setOptions(opts);
                    if (defaultOrder) {
                      let frmOrder: FormControl = this.ctrlBillingDomainOrderCtrl.getFormControl();
                      frmOrder.setValue(this.encounterRef.BILLS[0].superbill_charges_key);
                    }
                  }

                  if (loadMedServices) {
                    this.loadMedicalServices();
                  }
                }
              },
              error => {
                if (loadMedServices) {
                  this.addBill();
                  this.loadMedicalServices();
                }
              });
          }
          else {
            opts = bills.map(b => {
              let orddesc = Iceutility.isTextDateTime(b.created) ? Iceutility.getDateTextEx(b.created) : Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(b.created));
              orddesc += " - " + b.superbill_charges_key.substr(0, 10)
              return { value: b.superbill_charges_key, name: orddesc }
            });
            opts.push(this.newOrder);

            this.ctrlBillingDomainOrderCtrl.setOptions(opts);

            // select an order if there is only one
            // else select the latest order
            if (defaultOrder) {
              if (opts[0].name === this.newOrder.name || opts.length === 2) {
                selectedBill = opts[0].value;
              } else {
                selectedBill = opts[opts.length - 2].value;
              }
              let frmOrder: FormControl = this.ctrlBillingDomainOrderCtrl.getFormControl();
              frmOrder.setValue(selectedBill);
            }

            if (loadMedServices) {
              this.loadMedicalServices();
            }
          }
        }
      },
      error => {
        console.log(error);
        if (loadMedServices) {
          this.addBill();
          this.loadMedicalServices();
        }
      });
  }

  public addBill(): void {
    let domObj = this.getBillingDomain();
    let frmOrder: FormControl = this.ctrlBillingDomainOrderCtrl.getFormControl();
    if (frmOrder.value == "" && domObj != null && domObj.length > 0) {
      let bucket = new superbillcharges();
      bucket.from_account_type = this.appSvc.getCurrentAccountType();
      bucket.from_trans_account = this.appSvc.getCurrentAccount();
      bucket.to_account_type = this.getBillingType();
      bucket.to_trans_account = domObj[0].value;
      bucket.bill_status = IceTypes.trans_status.isNone;
      bucket.bill_to = domObj[0].name;
      this.accSvc.insertBill(bucket.from_trans_account, bucket.from_account_type, bucket).subscribe(
        data => {
          if (data != null && data.length > 0) {
            let insertedBill: superbillcharges = <superbillcharges>data[0];
            if (this.sourceRef != null && this.sourceRef.length > 1 && Iceutility.toLong(this.sourceRef[0]) == IceTypes.SourceType.srcEncounterNotes) {
              this.accSvc.assignBilltoEncounter(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(),
                this.sourceRef[1], insertedBill.superbill_charges_key).subscribe(
                  enc => {
                    if (enc != null && enc.length > 0)
                      this.encounterRef = enc[0]; // reset with updated encounter

                    this.updateBillingControl(insertedBill);
                    this.showNotificationMessage(IceTypes.LOGTYPE.ltUserAlert, "New service charge bucket has been created")
                  },
                  err => {
                    console.log(err);
                  }
                );
            }
            else {
              this.updateBillingControl(insertedBill);
            }
          }
        },
        error => {
          console.log(error);
        });
    }
  }

  /////////////////////////////////////
  // Events
  public onControlChange(event) {
    if (event.selectSettings != null) {
      switch (event.selectSettings.id) {
        case BillingActionDomainType: {
          this.billingDomainNameAndOrderSection.setShow(true);
          this.ctrlBillingDomainNameCtrl.getFormControl().setValue("");
          this.ctrlBillingDomainNameCtrl.setOptions([], true);
          this.ctrlBillingDomainOrderCtrl.getFormControl().setValue("");
          this.ctrlBillingDomainOrderCtrl.setOptions([this.newOrder], true);
          let accountType = this.ctrlBillingDomainType.getFormControl().value;

          this.showPatientSections = accountType === IceTypes.ACCOUNT_TYPE.actPatient;

          switch (this.getBillingType()) {
            case IceTypes.ACCOUNT_TYPE.actPatient: {
              // Fall through and do lookup upon keyword search
              if (this.sourceRef == null) {
                this.getPatientDiagnosis(accountType); // To do this code should be removed.
              }
              break;
            }
            case IceTypes.ACCOUNT_TYPE.actProvider:
            case IceTypes.ACCOUNT_TYPE.actFacility: {
              this.appSvc.setDomainNameList(this.ctrlBillingDomainNameCtrl, true, this.proSvc.getProviders());
              break;
            }
            case IceTypes.ACCOUNT_TYPE.actPharmacy: {
              this.appSvc.setDomainNameList(this.ctrlBillingDomainNameCtrl, true, this.pharmSvc.getPharmacies());
              break;
            }
            case IceTypes.ACCOUNT_TYPE.actVendor: {
              this.appSvc.setDomainNameList(this.ctrlBillingDomainNameCtrl, true, this.vendorSvc.getVendors());
              break;
            }
            case IceTypes.ACCOUNT_TYPE.actPayer: {
              this.appSvc.setDomainNameList(this.ctrlBillingDomainNameCtrl, true, this.payerSvc.getPayers());
              break;
            }
            case IceTypes.ACCOUNT_TYPE.actSubscriber: {
              // Fall through and do lookup upon keyword search
              break;
            }
            default: {
              // To do error to user
              return;
            }
          }
          break;
        }
        case BillingActionDomainOrder: {
          this.resetView();
          this.updateItemSubmitControls();
          this.addBill();
          this.loadMedicalServices();
          this.encounters = [];
          break;
        }
      }
    }
    else if (event.autocompleteSettings != null) {
      switch (event.autocompleteSettings.id) {
        case BillingActionNameofDomain: {
          this.updateItemSubmitControls();
          let domObj = this.getBillingDomain();
          if (domObj != null && domObj.length > 0) {
            this.toDomain = domObj[0].value;
            this.setBillToOrders(domObj[0].value);
          }
          // update the breadcrumb
          this.breadcrumbStoreService.updateBreadcrumb(BreadcrumType.btYard.toString(), {
            display: domObj[0].name,
            data: null,
            active: true,
            link: "",
            history: []
          });
          break;
        }
        case OtherItemTitle: {
          let ctrlValue = JSON.parse(event.autocompleteSettings.formControl.value);
          if (ctrlValue && ctrlValue.length > 0) {
            let selectedItem = event.autocompleteSettings.properties.menuItems.find(m => m.value === ctrlValue[0].value && m.name === ctrlValue[0].name);
            this.newItem["itemNo"] = selectedItem ? selectedItem.itemNo : "";
            this.newItem["value"] = ctrlValue[0].value;
            this.newItem["name"] = ctrlValue[0].name;
          }
        }
      }
    }
    else if (event.autocompleteRemoveSettings != null) {
      switch (event.autocompleteRemoveSettings.id) {
        case BillingActionNameofDomain: {
          this.ctrlBillingDomainOrderCtrl.getFormControl().setValue("");
          this.ctrlBillingDomainOrderCtrl.setOptions([this.newOrder], true);
          this.resetView();
          break;
        }
        case BillingActionDomainOrder: {
          break;
        }
        case OtherItemTitle:
          this.newItem = {};
          break;
      }
    }
    else if (Iceutility.isdefined(event.autocompleteQuerySettings)) {
      switch (event.autocompleteQuerySettings.id) { // To do: Move this to the new autocompleteQuery event
        case BillingActionNameofDomain: {
          if (event["value"] != null && event["value"].length >= 3) {
            switch (this.getBillingType()) {
              case IceTypes.ACCOUNT_TYPE.actPatient: {
                this.appSvc.setDomainNameList(this.ctrlBillingDomainNameCtrl, true, this.domainSvc.getPatientsByKeyword(this.appSvc.getCurrentAccountType(), this.appSvc.getCurrentAccount(), IceTypes.PatientSearchType.ptSearchKeyword, event["value"]));
                break;
              }
              case IceTypes.ACCOUNT_TYPE.actSubscriber: {
                this.appSvc.setDomainNameList(this.ctrlBillingDomainNameCtrl, true, this.domainSvc.getSubscribersByKeyword(this.appSvc.getCurrentAccountType(), this.appSvc.getCurrentAccount(), IceTypes.PatientSearchType.ptSearchKeyword, event["value"]));
                break;
              }
            }
          }
          break;
        }
        case OtherItemTitle: {
          if (Iceutility.isdefined(event["value"]) && event["value"].length > 2) {
            this.bindOtherItemsSource(event["value"]);
          }
          break;
        }
      }
    }
    else if (Iceutility.isdefined(event.keydownEnterSettings)) {
      switch (event.keydownEnterSettings.columnName) {
        case "quantity": {
          let billkey = this.getBillingOrder();

          let itemParams = {
            itemkey: event.tableRowData["medical_service_key"],
            quantity: Iceutility.toDouble(event.currentTarget.value).toFixed(2),
          };

          this.accSvc.billServiceScanItemQuantity(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), billkey, itemParams).subscribe(
            data => {
              if (data == null || data.length == 0) return;
            },
            error => {
              this.showNotificationMessage(IceTypes.LOGTYPE.ltError, this.serviceErrorMessage);
            });
        }
          break;
      }
    }
    else if (Iceutility.isdefined(event.buttonSettings)) {
      let billKey = this.getBillingOrder(),
        currentAct = this.appSvc.getCurrentAccount(),
        currentActType = this.appSvc.getCurrentAccountType();

      switch (event.buttonSettings.id) {
        case StatusCheckbox: {
          if (event.checked) {
            this.showHideProgressSpinner();

            if (event.tableRowData["src_type"] === IceTypes.SourceType.srcOther.toString()) {
              this.newItem["value"] = event.tableRowData["base_code_reference_key"];
              this.newItem["itemNo"] = event.tableRowData["code"];
              this.newItem["itemName"] = event.tableRowData["name"];
              this.newItem["quantity"] = event.tableRowData["quantity"];
              this.newItem["price"] = event.tableRowData["price"];
              this.newItem["sbkey"] = event.tableRowData["superbill_key"];
              this.processItemEntry();
            } else {
              let key = event.tableRowData["medical_service_key"] ? event.tableRowData["medical_service_key"] : event.tableRowData["base_code_reference_key"],
                domObj = this.getBillingDomain(),
                params = {
                  billtotype: this.getBillingType(), // To do this should be checked for validity as when page is embeded this may not be valid
                  billto: domObj != null && domObj.length > 0 ? domObj[0].value : "",
                  itemkey: "",
                  itemno: "",
                  srctype: event.tableRowData["src_type"],
                  codekey: key,
                  codetype: "",
                  subtype: event.tableRowData["sub_type"],
                  refsrctype: this.sourceRef != null && this.sourceRef.length > 0 ? Iceutility.toLong(this.sourceRef[0]) : IceTypes.SourceType.srcUndefined,
                  refsrckey: this.sourceRef != null && this.sourceRef.length > 1 ? this.sourceRef[1] : ""
                },
                isDiagnosis = params.srctype.toString() === IceTypes.SourceType.srcDiagnosis.toString();

              if (params.srctype != IceTypes.SourceType.srcDiagnosis.toString()) {
                params["sbkey"] = event.tableRowData["superbill_key"];
                params["quantity"] = Iceutility.toLong(event.tableRowData["quantity"]);
              } else {
                params["diagkey"] = key;
                params["code"] = event.tableRowData["code"];
              }
              if (isDiagnosis) {
                params["codekey"] = key ? key : "";
                params["diagkey"] = key ? key : "";
              }
              let scanApi = (params.srctype != IceTypes.SourceType.srcDiagnosis.toString()) ? this.accSvc.billServiceScan(currentAct, currentActType, billKey, params) : this.accSvc.billDiagnosisScan(currentAct, currentActType, billKey, params);

              scanApi
                .subscribe(
                  data => {
                    if (data == null || data.length == 0) return;

                    // this is new billing order so update the autocomplete source and select the value
                    if (Iceutility.isStringUndefinedNullOrEmpty(billKey)) {
                      let fndBills: superbillcharges[] = data.filter(obj => "SUPERBILL_CHARGES" == obj.gettablename());
                      if (fndBills.length > 0) {
                        if (this.sourceRef != null && this.sourceRef.length > 1 && Iceutility.toLong(this.sourceRef[0]) == IceTypes.SourceType.srcEncounterNotes) {
                          this.accSvc.assignBilltoEncounter(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(),
                            this.encounterRef.encounter_key, fndBills[0].superbill_charges_key).subscribe(
                              enc => {
                                if (enc != null && enc.length > 0)
                                  this.encounterRef = enc[0]; // reset with updated encounter
                                this.updateBillingControl(fndBills[0]);
                              },
                              err => {
                                console.log(err);
                              }
                            );
                        }
                        else {
                          this.updateBillingControl(fndBills[0]);
                        }
                      }
                    }
                    let medService: medicalservice[] = data.filter(obj => "MEDICAL_SERVICE" == obj.gettablename()),
                      from = "", to = "",
                      sec = this.sections.find(s => s.tag === "ServiceSection" + event.tableRowData["src_type"]),
                      diagnosis_key = "";
                    if (Iceutility.isdefined(sec)) {
                      sec.properties["checked"] = true;
                    }
                    this.getEncocunters(medService);

                    if (isDiagnosis) {
                      if (data.length > 0 && data[0].constructor.name === "superbillcharges") {
                        let diag = data[0].DIAGS.find(d => d.diagnosis_key === params["diagkey"]);
                        diagnosis_key = diag ? diag.diagnosis_key : "";
                        from = diag ? diag.onset_of_illness_date : "";
                        to = diag ? diag.resolution_date : "";
                      } else {
                        diagnosis_key = data.diagnosis_key;
                        from = Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(data.onset_of_illness_date));
                        to = Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(data.resolution_date));
                      }

                      event.tableRowData["base_code_reference_key"] = diagnosis_key;
                      event.tableRowData["from"] = Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(from), null, false);
                      event.tableRowData["to"] = Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(to), null, false);
                    } else if (Iceutility.isdefined(medService) && medService.length > 0) {
                      let tempMedServiceObj = medService[0];
                      if (tempMedServiceObj["SVCDTS"] && tempMedServiceObj["SVCDTS"].length > 0) {
                        from = Iceutility.isTextDateTime(tempMedServiceObj["SVCDTS"][0].date_required) ? Iceutility.getDateTextEx(tempMedServiceObj["SVCDTS"][0].date_required, null, false) : Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(tempMedServiceObj["SVCDTS"][0].date_required, false), null, false);
                        to = Iceutility.isTextDateTime(tempMedServiceObj["SVCDTS"][0].end_date_required) ? Iceutility.getDateTextEx(tempMedServiceObj["SVCDTS"][0].end_date_required, null, false) : Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(tempMedServiceObj["SVCDTS"][0].end_date_required, false), null, false);
                      }
                      // update row with medical service data
                      event.tableRowData["medical_service_key"] = medService[0].medical_service_key;
                      event.tableRowData["from"] = from;
                      event.tableRowData["to"] = to;
                      event.tableRowData["price"] = tempMedServiceObj.price;
                      this.grandTotal += Iceutility.toDouble(event.tableRowData["price"]) * params["quantity"];
                      this.setTotal();
                      this.showNotificationMessage(IceTypes.LOGTYPE.ltUserAlert, "The service was successfully added");
                    }
                    this.showHideProgressSpinner(false);
                  },
                  error => {
                    this.showNotificationMessage(IceTypes.LOGTYPE.ltError, this.serviceAddErrorMessage);
                    this.showHideProgressSpinner(false);
                  });
            }
          } else {
            let isDiagnosis = event.tableRowData["src_type"].toString() === IceTypes.SourceType.srcDiagnosis.toString();
            let params = {
              itemKey: event.tableRowData["medical_service_key"]
            };
            
            this.showDeleteConfirmation(isDiagnosis, currentAct, currentActType, billKey, params, event);
          }
        }
      }
    }
  }

  private processItemEntry(): boolean {
    let domBillType = this.getBillingType(),
      domBillObj = this.getBillingDomain(),
      billkey = this.getBillingOrder(),
      bill = domBillObj != null && domBillObj.length > 0 ? domBillObj[0].value : null;

    let billParams = {
      billtotype: this.toDomainType ? this.toDomainType : domBillType,
      billto: bill,
      itemkey: this.newItem["value"],
      itemno: this.newItem["itemNo"],
      sbkey: this.newItem["sbkey"],
      srctype: IceTypes.SourceType.srcOther,
      codekey: "",
      codetype: "",
      itemname: this.newItem["itemName"],
      quantity: Iceutility.toDouble(this.newItem["quantity"]),
      price: Iceutility.toDouble(this.newItem["price"]),
      refsrctype: Iceutility.toLong(this.sourceRef[0]),
      refsrckey: this.sourceRef != null && this.sourceRef.length > 1 ? this.sourceRef[1] : ""
    };

    if (!Iceutility.isdefined(billParams.itemkey) || billParams.itemkey === "") {
      this.showNotificationMessage(IceTypes.LOGTYPE.ltWarning, "Please select an item from available items");
      this.resetNewOtherItemPanel();
      this.showHideProgressSpinner(false);
      return;
    }

    this.resetNewOtherItemPanel();
    this.accSvc.billServiceScan(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), billkey, billParams).subscribe(
      data => {
        if (data == null || data.length == 0) return;

        // Clear Entry
        this.newItem = {};
        let mSvc: medicalservice = null,
          from = "", to = "",
          foundmSvc = data.filter(obj => "MEDICAL_SERVICE" == obj.gettablename());

        if (foundmSvc.length > 0) {
          mSvc = foundmSvc[0];

          if (mSvc["SVCDTS"] && mSvc["SVCDTS"].length > 0) {
            from = Iceutility.isTextDateTime(mSvc["SVCDTS"][0].date_required) ? Iceutility.getDateTextEx(mSvc["SVCDTS"][0].date_required, null, false) : Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(mSvc["SVCDTS"][0].date_required, false), null, false);
            to = Iceutility.isTextDateTime(mSvc["SVCDTS"][0].end_date_required) ? Iceutility.getDateTextEx(mSvc["SVCDTS"][0].end_date_required, null, false) : Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(mSvc["SVCDTS"][0].end_date_required, false), null, false);
          }

          let obj = {
            name: mSvc.service_description,
            code: mSvc.code,
            price: mSvc.price,
            from: from,
            to: to,
            quantity: Iceutility.toDouble(mSvc.quantity),
            total: Iceutility.toDouble(mSvc.quantity) * Iceutility.toDouble(mSvc.price),
            src_type: mSvc.src_type,
            superbill_key: "",
            base_code_reference_key: billParams["itemkey"],
            medical_service_key: mSvc.medical_service_key,
            checked: true,
            trans_account: mSvc.trans_account,
            unit_code: billParams["itemno"]
          };
          this.grandTotal += obj["total"];
          this.setTotal();
          ////////////////////////////
          // 7/8/2025 - To do remove this code, I don't think it's meant to add an item
          //this.srcTypeMapDataSource[mSvc.src_type].data.push(obj);
          //this.srcTypeMapDataSource[mSvc.src_type]._updateChangeSubscription();
          this.showHideProgressSpinner(false);
          this.getEncocunters([foundmSvc]);
        }
      },
      error => {
        this.showNotificationMessage(IceTypes.LOGTYPE.ltError, this.serviceAddErrorMessage);
        this.showHideProgressSpinner(false);
      });
    return true;
  }

  public processServiceEdit(rowData: any) {
    if (rowData == null) return;

    let domBillType = this.getBillingType(),
      billkey = this.getBillingOrder();

    let billParams = {
      billtotype: this.toDomainType ? this.toDomainType : domBillType,
      itemkey: rowData["medical_service_key"],
      code: rowData["code"],
      price: rowData["price"],
      quantity: rowData["quantity"],
      from: Iceutility.convertToUTCEx(rowData["from"]),
      to: Iceutility.convertToUTCEx(rowData["to"])
    };

    this.showHideProgressSpinner();

    this.accSvc.billServiceScanItemCode(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), billkey, billParams).subscribe(
      data => {
        if (data == null || data.length == 0) return;
        this.showHideProgressSpinner(false);
      },
      error => {
        this.showNotificationMessage(IceTypes.LOGTYPE.ltError, this.serviceAddErrorMessage);
        this.showHideProgressSpinner(false);
      });
  }

  public onButtonClick(event) {
    if (event.buttonSettings != null && event.buttonSettings.properties != null && event.buttonSettings.properties.section && event.buttonSettings.properties.section.length > 0) {
      let btnId: string = event.buttonSettings.id;
      if (event.buttonSettings.properties.section == this.newOtherItemSectionTag) {
        if (btnId.indexOf("Cancel") >= 0) {
          this.resetNewOtherItemPanel();
        }
        else if (btnId.indexOf("Save") >= 0) {
          if (this.appSvc.processEditPanelSectionButtons(this.newOtherItemSectionTag, event.buttonSettings.id)) {
            this.processItemEntry();
          }
        }
      }
      else {
        let rowData = this.appSvc.getEditPanelSectionRow(event.buttonSettings.properties.section);
        if (this.appSvc.processEditPanelSectionButtons(event.buttonSettings.properties.section, event.buttonSettings.id)) {
          this.processServiceEdit(rowData);
          this.calculateTotal(event, rowData["quantity"], false, rowData);
        }
      }
    }
  }

  public onRowClick(event) {
    //super.onRowClick(event);
  }

  public onAddRowButtonClick(event) {
    if (event.matTableSettings != null) {
      //switch (event.matTableSettings.tag) {
      //  case this.tableTagResults: {
      //    this.appSvc.showEditPanelSection(this.sectionTagNewItem);
      //    this.newItem = null; // reset
      //    this.newItem = new otheritemsindex();
      //    this.newItem["code_object"] = null; // this is a temp var
      //    this.newItem.item_stock_num = Iceutility.guid(true).substr(0, 10).toUpperCase();
      //    this.appSvc.editPanelSectionUpdate(this.sectionTagNewItem, false, this.newItem);
      //    break;
      //  }
      //}
    }
  }

  public onMatGridAddRowButtonClick(event) {
    this.appSvc.showEditPanelSection(this.newOtherItemSectionTag, -1);
    this.appSvc.editPanelSectionUpdate(this.newOtherItemSectionTag, false, this.newItem);
  }

  public onMatGridRowActionClick(event) {
    if (event["rowData"] == null) {
      // To do log error
      return;
    }

    /*
    let actionType = this.getBillingAction();

    if (event.actionItem == null) return;
    if (itemQuickActionAdd.value == event.actionItem.value) {
      if (actionType == OrderActionType.oatCheckout) {
        let item = <otheritemsindex>event["rowData"];
        if (item == null) {
          // To do log error
          return;
        }
        this.processItemEntry(item.item_stock_num, item.other_items_key);
      }
      else {
        let recv = <otheritemsreceiving>event["rowData"];
        if (recv == null) {
          // To do log error
          return;
        }
        this.processItemEntry("", recv.other_items_key);
      }
    }
    else if (itemQuickActionEdit.value == event.actionItem.value) {
      let item = <otheritemsindex>event["rowData"];
      if (item == null) {
        // To do log error
        return;
      }
      this.router.navigate([this.navSvc.buildRoute("accounting/inventory/item/" + item.other_items_key, false)]);
    }
    else if (ItemActionType.oatRemoveFromOrder == event.actionItem.value) {
      let ordObj = this.getBillingOrder();
      let billkey = ""
      if (ordObj != null && ordObj.length > 0)
        billkey = ordObj[0].value;

      if (actionType == OrderActionType.oatCheckout) {
        let item = <otheritemsindex>event["rowData"];
        if (item == null) {
          // To do log error
          return;
        }
        let itemParams = {
          itemkey: item["medical_service_key"],
        };

        this.accSvc.billServiceScanItemRemove(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), billkey, itemParams).subscribe(
          data => {
            this.orderItemsDataSource.data = this.orderItemsDataSource.data.filter(msv => msv.medical_service_key != itemParams.itemkey);
            this.changeDetectorRefs.detectChanges();
          },
          error => {
            // To do, log error
          });
      }
      else {
        let recv = <otheritemsreceiving>event["rowData"];
        if (recv == null) {
          // To do log error
          return;
        }
        let recvParams = {
          recvkey: recv["other_items_receiving_key"],
        };

        this.accSvc.itemReceivingScanItemRemove(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), billkey, recvParams).subscribe(
          data => {
            this.purchaseItemsDataSource.data = this.purchaseItemsDataSource.data.filter(recv => recv.other_items_receiving_key != recvParams.recvkey);
            this.changeDetectorRefs.detectChanges();
          },
          error => {
            // To do, log error
          });
      }
    }
    */
  }

  public onMatGridRowClick(event) {
    // not progressing with row click when click on checkbox
    if (event.rowData == null || event.rowData["checked"] == false || event.target.className.indexOf("mat-checkbox") >= 0) return;

    if (event.matTableSettings != null) {
      let editSectionTag = this.buildSectionTag(Iceutility.toLong(event.rowData["src_type"]), true);
      this.appSvc.showEditPanelSection(editSectionTag, -1);
      this.appSvc.editPanelSectionUpdate(editSectionTag, false, event.rowData);
    }
  }

  /////////////////////////////////////
  // private functions
  private buildSectionTag(srctyp: IceTypes.SourceType, isEditPanel: boolean = false): string {
    return SectionName + srctyp.toString() + (isEditPanel ? "-Edit" : "");
  }

  private parseTableKey(val: string): IceTypes.SourceType {
    let srctype: IceTypes.SourceType = IceTypes.SourceType.srcUndefined;
    if (!Iceutility.isdefined(val)) return srctype;
    let parts = val.split("-");
    if (parts.length > 0) {
      srctype = <IceTypes.SourceType>Iceutility.toLong(parts[1]);
    }
    return srctype;
  }

  private calculateTotal(event, quantity, isServiceRemoved: boolean = false, rowDataOverride: any = null) {
    if (!isServiceRemoved) {
      if (rowDataOverride != null) {
        let originalPrice = Iceutility.toDouble(rowDataOverride.price),
          calculatedPrice = Iceutility.toDouble(quantity) * originalPrice;
        rowDataOverride.total = calculatedPrice.toFixed(2);
      }
      else {
        let originalPrice = Iceutility.toDouble(event.tableRowData.price),
          calculatedPrice = Iceutility.toDouble(quantity) * originalPrice;
        event.tableRowData.total = calculatedPrice.toFixed(2);
      }
    }

    this.grandTotal = 0;
    for (let key in this.srcTypeMapDataSource) {
      if (this.srcTypeMapDataSource[key] == null) continue;

      let rows = this.srcTypeMapDataSource[key].data;
      for (var irow = 0; irow < rows.length; irow++) {
        if (rows[irow].checked) {
          this.grandTotal += Iceutility.toDouble(rows[irow].total);
        }
      }
    }
    this.setTotal();
  }

  private hideNavigation() {
    // hide the nav bar
    let navElem: HTMLElement = document.getElementById("mainNav");
    navElem.style.display = "none";

    // remove margin, padding from body and set the background color
    let body: HTMLElement = document.getElementsByTagName("body").item(0) as HTMLElement;
    body.style.paddingTop = "0";
    body.style.marginBottom = "0";
    body.style.backgroundColor = "white";

    // remove margin from the main content
    let wrapperElem: HTMLElement = document.getElementsByClassName("content-wrapper").item(0) as HTMLElement;
    wrapperElem.style.marginLeft = "0";

    // adjust margin of the log panel
    let logPanelElem: HTMLElement = document.getElementsByClassName("log-panel").item(0) as HTMLElement;
    if (logPanelElem) {
      logPanelElem.style.marginLeft = "30px";
    }

    // hide the ping pilot control
    let pingPilotElem: HTMLElement = document.getElementById("pingpilot-master-container");
    if (pingPilotElem) {
      pingPilotElem.style.display = "none";
    }
  }

  private loadMedicalServices(dataToLoad: any = null) {
    let ordObj = this.getBillingOrder();
    if (ordObj != null) {
      this.showHideProgressSpinner();

      // Used for processing and completing the billing data
      let completeServices: Function = (data) => {
        if (data == null || data.length == 0) {
          return;
        }

        let foundBill = data.filter(obj => key == obj.superbill_charges_key),
          medicalServices = data.length > 0 ? data.slice(1, data.length) : [];

        if (foundBill.length == 0) return;

        let bill: superbillcharges = <superbillcharges>foundBill[0];
        if (bill == null) return;

        let charges = [];
        for (let ichrg = 0; ichrg < bill.CHARGES.length; ichrg++) {
          let chrg: medicalservicereference = <medicalservicereference>bill.CHARGES[ichrg];

          let foundMedSvc = data.filter(obj => obj.medical_service_key == chrg.medical_service_key);
          if (foundMedSvc.length == 0) continue;

          let chrgObj = {
            medical_service_reference_key: chrg.medical_service_reference_key,
            medical_service_key: chrg.medical_service_key,
            sub_type: chrg.sub_type,
            item_abstract: foundMedSvc[0].service_description,
            quantity: foundMedSvc[0].quantity,
            price: foundMedSvc[0].price,
            unit_code: foundMedSvc[0].unit_code,
            total_amount: foundMedSvc[0].total_amount
          };
          charges.push(chrgObj);

          if (foundMedSvc[0].unit_code != null && foundMedSvc[0].unit_code.length > 0) {
            this.medCodeSvc.getCodes("QUANTITYUNITOFMEASURE", "", foundMedSvc[0].unit_code, "").subscribe(
              data => {
                if (data && data.length > 0 && data[0] != null) {
                  chrgObj.unit_code = data[0].title;
                }
              },
              error => {
                console.log(JSON.stringify(this.medCodeSvc.getLastErrors()));
              });
          }
        }

        this.getBillingTemplates(medicalServices, bill.DIAGS);
        this.checkAndAssignBill(bill.superbill_charges_key, this.ctrlBillingDomainOrderCtrl.getOptions());
        this.getEncocunters(medicalServices);

        let svcKeys = [];
        for (let iSvc = 0; iSvc < medicalServices.length; iSvc++) {
          svcKeys.push(medicalServices[iSvc].medical_service_key);
        }

        this.medServiceKeys = svcKeys;
      };

      let key = ordObj;
      if (!Iceutility.isStringUndefinedNullOrEmpty(key)) {
        if (dataToLoad != null) {
          completeServices(dataToLoad);
        }
        else {
          this.accSvc.getBill(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), key).subscribe(
            data => {
              completeServices(data);
            },
            error => {
              console.log(error);
            });
        }
      } else {
        this.getBillingTemplates([], []);
      }
    }
  }

  checkAndAssignBill(sbKey: string, opts: any[]) {
    if (this.encounterRef == null || opts == null) return;

    let fndBill = this.encounterRef.BILLS.filter(b => b.superbill_charges_key == sbKey);
    if (fndBill.length == 0) {
      let fndOpt = opts.filter(o => o.value == sbKey);
      if (fndOpt.length > 0 && Iceutility.yesnomodal("Would you like to assign Super-Bill (Bucket): " + fndOpt[0].name + " to this Patient Encounter?")) {
        this.accSvc.assignBilltoEncounter(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(),
          this.encounterRef.encounter_key, sbKey).subscribe(
            enc => {
              if (enc != null && enc.length > 0)
                this.encounterRef = enc[0]; // reset with updated encounter
            },
            err => {
              console.log(err);
            }
          );
      }
    }
  }

  private renderMedicalServiceTable(tableKey: string, data: object, isServiceChecked: boolean = false, showAddButton: boolean = false) {
    let sectionTag = this.buildSectionTag(Iceutility.toLong(tableKey)), section = this.sections.find(s => s.tag === sectionTag);

    if (this.hasAccountingJournalPermission) {
      this.grandTotalSection.setShow(true);
    }

    if (!Iceutility.isdefined(section)) {
      section = new IcepanelsectionSettings(sectionTag, { class: [""], styles: { width: "100%" } }, [], [], []).setShow(true);
      this.sections.push(section);
    }

    if (this.srcTypeMapDataSource[tableKey]) {
      if (Iceutility.isdefined(data)) {
        this.srcTypeMapDataSource[tableKey].data.push(data);
      }
      this.srcTypeMapDataSource[tableKey]._updateChangeSubscription();
    } else {
      this.sectionMap[sectionTag] = section;
      this.srcTypeMapDataSource[tableKey] = new MatTableDataSource<any>([]);
      if (Iceutility.isdefined(data)) {
        this.srcTypeMapDataSource[tableKey].data.push(data);
      }
      

      let columns = [
        new iceColumnDefinition("name", AccountingService.getSourceType(parseInt(tableKey)), false, false,
          new IcecontrolSettings("icelabel", { width: "200px" }, null, null)),
        new iceColumnDefinition("code", "Code", false, false,
          new IcecontrolSettings("icelabel", { width: "100px" }, null, null)),
        new iceColumnDefinition("from", "From", false, false,
          new IcecontrolSettings("icelabel", { width: "100px" }, null, null)),
        new iceColumnDefinition("to", "To", false, false,
          new IcecontrolSettings("icelabel", { width: "100px" }, null, null))
      ];

      if (Iceutility.toLong(this.serviceSelectionPermission) != userTypes.USER_FEATURE_ACCESS.ufaNone) {
        columns.splice(0, 0, new iceColumnDefinition("checked", "", false, false,
          new IcecontrolSettings("icecheckbox", { width: "50px", checked: isServiceChecked }, null, null, StatusCheckbox).createFormControl(isServiceChecked, [])));
      }

      if (tableKey != IceTypes.SourceType.srcDiagnosis.toString() && this.hasAccountingJournalPermission) {
        columns.push(new iceColumnDefinition("price", "Price", false, false,
          new IcecontrolSettings("icelabel", { width: "100px" }, null, null)));
        columns.push(new iceColumnDefinition("quantity", "Quantity", false, false,
            new IcecontrolSettings("iceinput", { width: "50px", inputType: "number" }, null, {
              change: (event) => {
                let isChecked = event.tableRowData["checked"],
                  billKey = this.getBillingOrder(),
                  itemParams = {
                    itemkey: event.tableRowData["medical_service_key"],
                    quantity: Iceutility.toDouble(event.currentTarget.value),
                  };

                if (isChecked) {
                  this.showHideProgressSpinner();
                  this.accSvc.billServiceScanItemQuantity(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), billKey, itemParams).subscribe(
                    data => {
                      if (data == null || data.length == 0) return;
                      this.calculateTotal(event, itemParams.quantity);
                      this.showHideProgressSpinner(false);
                    },
                    error => {
                      this.showHideProgressSpinner(false);
                      this.showNotificationMessage(IceTypes.LOGTYPE.ltError, this.serviceAddErrorMessage);
                    });
                } else {
                  let originalPrice = event.tableRowData.price,
                    calculatedPrice = itemParams.quantity * originalPrice;
                  event.tableRowData.total = calculatedPrice.toFixed(2);
                  event.tableRowData.quantity = itemParams.quantity;
                }
              }
            })));
        columns.push(new iceColumnDefinition("total", "Total", false, false,
            new IcecontrolSettings("icelabel", { width: "100px" }, null, null)));
      }
      columns.push(new iceColumnDefinition("medical_service_key", "medical_service_key", true));
      columns.push(new iceColumnDefinition("unit_code", "", false, false,
        new IcecontrolSettings("icehidden", { width: "1px" }, null, null)));
      columns.push(new iceColumnDefinition("base_code_reference_key", "base_code_reference_key", true));

      let resultsTable = new IceResponsiveMattableSettings(
        "TemplatesTable-" + tableKey,
        columns,
        this.srcTypeMapDataSource[tableKey],
        [], false, null, true
      ).showAddButton(showAddButton);
      section.properties["taxonomy_code"] = data ? data["taxonomy_code"] : "";
      section.tables.push(resultsTable);

      /////////////////
      // Edit Panel
      /// Contact Edit Panel
      let editControls = [
        new IcecontrolSettings("iceinput", { width: "100px" }, null, null, "code", "Code")
          .setControlName("code")
          .createFormControl(Iceutility.GetLocalDate(), [Validators.required]),
        new IcecontrolSettings("iceinput", { width: "100px", inputType: "number" }, null, null, "price", "Price")
          .setControlName("price")
          .createFormControl(0, [Validators.required]),
        new IcecontrolSettings("iceinput", { width: "100px", inputType: "number" }, null, null, "quantity", "Quantity")
          .setControlName("quantity")
          .createFormControl(0, [Validators.required]),
        new IcecontrolSettings("icedatepicker", { width: "100px" }, null, null, "from", "Select From Date")
          .setControlName("from")
          .createFormControl(Iceutility.GetLocalDate(), [Validators.required]),
        new IcecontrolSettings("icedatepicker", { width: "100px" }, null, null, "to", "Select To Date")
          .setControlName("to")
          .createFormControl(Iceutility.GetLocalDate(), [Validators.required])
      ];

      let editSectionTag = this.buildSectionTag(Iceutility.toLong(tableKey), true);
      this.sections.push(this.appSvc.viewEditPanelSection(editSectionTag, editControls));
      ////////////////
    }
    if (section.properties["taxonomy_code"] != this.activeTaxonomy && !section.properties["checked"]) {
      section.setShow(false);
    }
    if (isServiceChecked) {
      section.properties["checked"] = true;
      section.setShow(true);
    }
    if (tableKey === IceTypes.SourceType.srcOther.toString()) {
      section.properties["srcOther"] = true;
      section.setShow(true);
    }
    //this.sections = this.sections.sort((a, b) => { return a.tag.localeCompare(b.tag); });
  }

  private resetView() {
    this.grandTotal = 0;
    this.grandTotalControl.getFormControl().setValue(this.grandTotal);
    this.grandTotalSection.setShow(false);
    for (let key in this.sectionMap) {
      this.sectionMap[key].tables = [];
    }
    this.sectionMap = {};
    this.srcTypeMapDataSource = {};
    this.resetNewOtherItemPanel();
    this.taxonomyFilterSection.controls = [];
    this.taxonomyFilterSection.setShow(false);
    this.activeTaxonomy = "";
  }

  private setTotal() {
    this.grandTotalControl.getFormControl().setValue(this.grandTotal.toFixed(2));
  }

  private bindOtherItemsSource(keyword) {
    this.accSvc.getOtherItems(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), keyword).subscribe(
      data => {
        if (data == null || data.length == 0) {
          return;
        }
        let options = [];
        for (let iresult = 0; iresult < data.length; iresult++) {
          let item = data[iresult];
          options.push({ name: item.itm_name, value: item.other_items_key, itemNo: item.item_stock_num });
        }

        this.otherItemsTitleCtrl.setOptions(options);
      },
      error => {
        // To do, log error
      });
  }

  private resetNewOtherItemPanel() {
    this.appSvc.hideEditPanelSection(this.newOtherItemSectionTag);
    this.otherItemsTitleCtrl.getFormControl().reset();
    this.otherItemsTitleCtrl.setOptions([]);
    this.otherItemsPriceCtrl.getFormControl().reset();
    this.otherItemsQuantityCtrl.getFormControl().reset();
    this.newItem = {};
  }

  private setTaxonomyCodeList() {
    this.medCodeSvc.getCodes("TAXONOMY", "", "", "").subscribe(
      data => {
        if (data && data.length > 0 && data[0] != null) {
          this.taxonomyCodes = data.map(c => { return { code: c.code, description: c.description } });
        }
      },
      error => {
        console.log(JSON.stringify(this.medCodeSvc.getLastErrors()));
      });
  }

  onPeriodActionRequired(event) {
    if (event.value == "NoCurrentPeriod")
      this.hideAccountingPeriod = false;
    else
      this.hideAccountingPeriod = true;
  }

  private async onTaxonomyClick(event) {
    this.showHideProgressSpinner();
    this.appSvc.hideEditPanelSection(this.newOtherItemSectionTag);
    let filteredSections = this.sections.filter(r => r.tag.indexOf("ServiceSection") >= 0 && r.tag.indexOf("-Edit") === -1);

    await new Promise(resolve => {
      setTimeout(() => {
        for (var isection = 0; isection < filteredSections.length; isection++) {
          let sec = filteredSections[isection];
          if (event.value.toLowerCase() === "all") {
            if (sec.tag === this.newOtherItemSectionTag) continue;
            sec.setShow(true);
          } else if ((sec.properties["taxonomy_code"] && sec.properties["taxonomy_code"].toLowerCase() === event.value.toLowerCase()) ||
            sec.properties["srcOther"] || sec.properties["checked"]) {
            sec.setShow(true);
          } else {
            sec.setShow(false);
          }
        }
        this.showHideProgressSpinner(false);
      }, 300);
    });
  }

  private updateBillingControl(billToSet: superbillcharges) {
    if (billToSet == null) return;
    let opts = this.ctrlBillingDomainOrderCtrl.getOptions();
    if (opts.length == 0) {
      opts.push(this.newOrder);
    }

    let billdesc = Iceutility.isTextDateTime(billToSet.created) ? Iceutility.getDateTextEx(billToSet.created) : Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(billToSet.created));
    billdesc += " - " + billToSet.superbill_charges_key.substr(0, 10);
    if (this.encounterRef != null) {
      billdesc += " - Assigned to Encounter";
    }

    opts.push({ value: billToSet.superbill_charges_key, name: billdesc });

    let frmOrder: FormControl = this.ctrlBillingDomainOrderCtrl.getFormControl();
    frmOrder.setValue(billToSet.superbill_charges_key);
  }

  private buildAndRenderMedicalService(medicalServices) {
    for (let imedServ = 0; imedServ < medicalServices.length; imedServ++) {
      let medService = medicalServices[imedServ], from = "", to = "";
      if (medService["SVCDTS"] && medService["SVCDTS"].length > 0) {
        from = Iceutility.isTextDateTime(medService["SVCDTS"][0].date_required) ? Iceutility.getDateTextEx(medService["SVCDTS"][0].date_required, null, false) : Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(medService["SVCDTS"][0].date_required));
        to = Iceutility.isTextDateTime(medService["SVCDTS"][0].end_date_required) ? Iceutility.getDateTextEx(medService["SVCDTS"][0].end_date_required, null, false) : Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(medService["SVCDTS"][0].end_date_required));
      }
      let obj = {
        name: medService.service_description,
        code: medService.code,
        price: medService.price,
        from: from,
        to: to,
        quantity: Iceutility.toDouble(medService.quantity),
        total: Iceutility.toDouble(medService.quantity) * Iceutility.toDouble(medService.price),
        src_type: medService.src_type,
        superbill_key: medService.superbill_key,
        base_code_reference_key: medService.src_key, // other_items_key or base_code_reference_key
        medical_service_key: medService.medical_service_key,
        checked: true,
        trans_account: medService.trans_account,
        taxonomy_code: "",
        sub_type: "",
        unit_code: medService.unit_code
      };

      this.grandTotal += obj["total"];
      this.setTotal();
      this.renderMedicalServiceTable(medService.src_type, obj, true, obj.src_type === IceTypes.SourceType.srcOther.toString());
    }
  }

  private showNotificationMessage(type: IceTypes.LOGTYPE, message: string) {
    this.domainSvc.logMessage(type, message);
    Iceutility.scrollToTop();
  }

  private showHideProgressSpinner(show: boolean = true) {
    this.loaderSection.setLoading(show);
  }

  public onHeaderActionClick(event) {
    if (event.headerCtrl && event.headerCtrl.id == "") {
      return;
    }

    if (event.headerCtrl && event.headerCtrl.id == "Cancel") {
      // To do: Save Modified Prompt
      this.router.navigate([this.navSvc.buildRoute("accounting/servicechargehistory", false)]);
      return;
    }

    if (event.headerCtrl instanceof IcecontrolSettings) {
      let chargesKey = this.getBillingOrder();
      if (chargesKey != null && chargesKey.length > 0)
        this.router.navigate([this.navSvc.buildRoute("accounting/outstandingbalance/" + chargesKey, false)]);
    }
  }

  private getPatientDiagnosis(domain: string) {
    this.ptSvc.getProblems(domain).subscribe(
      data => {
        if (data == null || data.length == 0) return;

        let tableKey = IceTypes.SourceType.srcDiagnosis,
          obj = {};

        if (!Iceutility.isdefined(this.srcTypeMapDataSource[tableKey])) {
          this.renderMedicalServiceTable(tableKey.toString(), null, false, false);
        }

        for (var iDiagnosis = 0; iDiagnosis < data.length; iDiagnosis++) {
          let diagnosis = data[iDiagnosis];
          if (!Iceutility.isdefined(diagnosis)) continue;
          obj = {
            name: diagnosis.title,
            code: diagnosis.icd_code,
            from: Iceutility.getDateTextEx(diagnosis.onset_of_illness_date),
            to: !isNaN(diagnosis.resolution_date) ? Iceutility.getDateTextEx(diagnosis.resolution_date) : "",
            //price: code.price,
            //quantity: 1,
            //total: Iceutility.toLong(code.price),
            src_type: tableKey,
            superbill_key: "",
            base_code_reference_key: diagnosis.diagnosis_key,
            medical_service_key: "",
            checked: false,
            trans_account: "",
            taxonomy_code: "",
            sub_type: diagnosis.sub_type
          };

          if (this.srcTypeMapDataSource[tableKey]) {
            this.srcTypeMapDataSource[tableKey].data.push(obj);
          } else {
            this.srcTypeMapDataSource[tableKey] = new MatTableDataSource<any>([]);
            this.srcTypeMapDataSource[tableKey].data.push(obj);
          }
        }
      },
      error => {
      });
  }

  private getEncocunters(medicalServices: medicalservice[], resetCurrentEncounters: boolean = false) {
    let encountersKeys: string[] = [],
      encountersToLoad: encounterindex[] = [];

    this.appointmentKeys = [];

    for (let medSvc of medicalServices) {
      for (let note of medSvc.NOTES) {
        if (!encountersKeys.includes(note.encounter_key)) {
          encountersKeys.push(note.encounter_key);
        }
      }
    }

    this.ptSvc.getEncountersByKey(this.appSvc.getCurrentAccount(), !Iceutility.isStringUndefinedNullOrEmpty(this.toDomain) ? this.toDomain : this.appSvc.getCurrentPatient(), encountersKeys, this.appSvc.getCurrentAccountType())
      .subscribe(response => {
        for (let encounter of response) {
          let item = encounter[0];
          item._time_slot_start_display = item.time_slot_start;
          item._time_slot_end_display = item.time_slot_end;
          item._appointment_status_text = ScheduleService.getApptStat(Iceutility.toLong(item.appointment_status));
          item._appointment_type_text = ScheduleService.getAppointmentType(item.appointment_type);
          item._rto_text = ScheduleService.getReturnToOfficeValue(item.rto_type);

          if (!this.encounters.find(e => e.encounter_key === item.encounter_key)) {
            encountersToLoad.push(item);
          }

          if (!this.appointmentKeys.includes(item.appointment_key)) {
            this.appointmentKeys = this.appointmentKeys.concat(item.appointment_key);
          }
        }
        this.encounters = resetCurrentEncounters ? [...encountersToLoad] : this.encounters.concat(encountersToLoad);
      });
  }

  private showDeleteConfirmation(isDiagnosis, currentAct, currentActType, billKey, params, event) {
    let headerControls = [
      new IcecontrolSettings("icesubmitbutton", { class: "fas fa-check", width: "50px", tooltip: "Delete" }, null, null, "Delete"),
      new IcecontrolSettings("icecancelbutton", { class: "fas fa-times", width: "50px", tooltip: "Close" }, null, null, "Close")
    ];

    let sections = [
      new IcepanelsectionSettings("section1", { class: [""], styles: {} }, [],
        [new IcecontrolSettings("icelabel", { width: "200px", value: "Are you sure you want to remove this service?" }, null, null)], null)
    ];

    this.deleteConfirmationDialogRef = this.dialog.open(IcepanelDialog, {
      height: '220px',
      width: '550px',
      data: {
        record: {
          isDiagnosis, currentAct, currentActType, billKey, params, event
        },
        panel: new IcepanelSettings("", "", "Remove Service?", "", sections, headerControls)
          .enableForm(),
      }
    });

    let dialogRef = this.deleteConfirmationDialogRef;
    this.deleteConfirmationDialogRef.afterClosed().subscribe(result => {
      if (!Iceutility.isdefined(dialogRef.componentInstance) || !Iceutility.isdefined(dialogRef.componentInstance.data)) return;
      let hdrCtrl: IcecontrolSettings = <IcecontrolSettings>dialogRef.componentInstance.data.headerCtrl;
      if (hdrCtrl == null || hdrCtrl.id == "Close") {
        event.source.checked = true;
        event.checked = true;
        return;
      }

      this.showHideProgressSpinner();
      let recordToDelete = dialogRef.componentInstance.data.record;

      let removeApi = isDiagnosis ?
        this.accSvc.diagnosisServiceScanItemRemove(recordToDelete.currentAct, recordToDelete.currentActType, recordToDelete.billKey, recordToDelete.params)
        : this.accSvc.billServiceScanItemRemove(recordToDelete.currentAct, recordToDelete.currentActType, recordToDelete.billKey, recordToDelete.params);

      removeApi.subscribe(
        _ => {
          let srcType = recordToDelete.event.tableRowData["src_type"],
            sec = this.sections.find(s => s.tag === "ServiceSection" + srcType);
          if (Iceutility.isdefined(sec)) {
            sec.properties["checked"] = false;
          }

          if (srcType === IceTypes.SourceType.srcOther.toString()) {
            let index = this.srcTypeMapDataSource[srcType].data.findIndex(d => d.unit_code === event.tableRowData["unit_code"] && d.medical_service_key === event.tableRowData["medical_service_key"] && d.base_code_reference_key === event.tableRowData["base_code_reference_key"]);
            if (index >= 0) {
              this.srcTypeMapDataSource[srcType].data.splice(index, 1);
              this.srcTypeMapDataSource[srcType]._updateChangeSubscription();
            }
          } else {
            recordToDelete.event.tableRowData["isChecked"] = false;
            recordToDelete.event.tableRowData["from"] = "";
            recordToDelete.event.tableRowData["to"] = "";
            recordToDelete.event.tableRowData["medical_service_key"] = null;
          }
          if (srcType != IceTypes.SourceType.srcDiagnosis.toString()) {
            this.grandTotal -= Iceutility.toDouble(recordToDelete.event.tableRowData["price"]) * Iceutility.toLong(event.tableRowData["quantity"]);
            this.setTotal();
          }

          this.accSvc.getBill(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), billKey).subscribe(
            data => {
              let medicalServices = data.length > 0 ? data.slice(1, data.length) : [];
              this.getEncocunters(medicalServices, true);
              this.showHideProgressSpinner(false);
              this.showNotificationMessage(IceTypes.LOGTYPE.ltUserAlert, "The service was successfully removed");
            },
            error => {
              console.log(error);
              this.showHideProgressSpinner(false);
              this.showNotificationMessage(IceTypes.LOGTYPE.ltError, this.serviceErrorMessage);
            });
        },
        _ => {
          this.showNotificationMessage(IceTypes.LOGTYPE.ltError, this.serviceErrorMessage);
          this.showHideProgressSpinner(false);
        });

    });
  }
}
